import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/ImageTextBlock/ImageTextBlock.js
const ImageTextBlock = createSectionForm({
  icon: "layout-left-line",
  title: "Image & Text Block",
  fields: [
    { name: "title", label: "Title" },
    { name: "description", label: "Description", type: "richtext" },
    { name: "image", label: "Image", type: "media" },
  ],
});

export default ImageTextBlock;
